import { gameCardTexts } from "@/features/casino/localization/texts"

export function MissingGameCover() {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black-800">
      <span className="px-2 text-center text-[11px] font-medium uppercase tracking-wide text-default-400">
        {gameCardTexts.noImage}
      </span>
    </div>
  )
}
